import React, {useContext} from "react"
import { Helmet } from "react-helmet"
import { graphql } from "gatsby"
import Seo from '../components/seo'
import BlogHeader from '../components/blogheader'
import BlogFooter from '../components/blogfooter'
import Footer from "../components/footer"
import ShareButtons from '../components/sharebuttons'
import BeerInfo from "../components/beerInfo"
import { StoreContext } from "../context/store-context"
import Score from "../components/score"

export default function Template({
  data, pageContext
}) {
  const { addTagToSearch } = useContext(StoreContext)
  const { contentfulBlogPost: post } = data
  const params = typeof window !== `undefined` ? window.location.search : ``;
  return (
    <div>
      <Seo
        preview={post.preview}
        title={post.title}
        pic={post.seoPic}
        path={post.path}
        author={post.author}
        date={post.date}
      />
    <BlogHeader showPromo={false}/>
    <ShareButtons url={"https://www.filmfroth.com"+post.path} title={post.title} />
    {/* <EmailPop params={new URLSearchParams(params)}/> */}
    <div className="my-0 mx-auto max-w-4xl text-center pt-0 px-4 pb-6">
      <Helmet title={`Film & Froth - ${post.title}`} />
      <div>
        <h1 className="mt-4">{post.title}</h1>
        <br />
        {post.movieScore && <Score beer={false} score={post.movieScore} />}
        <br />
        <div className="post-author mb-3 text-xl">By: {post.author}</div>
        <div className="post-date mb-4">{post.date}</div>
        <div
          className="text-left text-lg leading-relaxed"
          dangerouslySetInnerHTML={{ __html: post.content.childMarkdownRemark.html }}
        />
      </div>
    {post.beerInfo && <BeerInfo onSelectTag={addTagToSearch} name={post.beerInfo.beer} type={post.beerInfo.type} score={post.beerInfo.score} brewery={post.beerInfo.brewery} abv={post.beerInfo.abv} tags={[post.beerInfo.type, post.beerInfo.brewery, post.beerInfo.genre]}/>}
    </div>
    <BlogFooter author = {post.author} one={pageContext.one} two={pageContext.two} three={pageContext.three} />
    <Footer />
    </div>
  )
}

export const pageQuery = graphql`
  query($place: String!) {
    contentfulBlogPost(path: { eq: $place }) {
      date(formatString: "MMMM DD, YYYY")
      path
      title
      preview
      author
      seoPic {
        gatsbyImageData(width: 1200, placeholder: BLURRED, formats: AUTO)
      }
      content {
        childMarkdownRemark {
          html
        }
      }
      beerInfo {
        genre
        brewery
        beer
        type
        abv
        score
      }
      movieScore
    }
  }
`